export default "__VITE_ASSET__DSbZxIja__"